export function bodyLock() {
    const bodyStyles = document.body.style.cssText;
    document.body.style.overflow = 'hidden';
    return bodyStyles;
}

export function bodyUnlock(oldStyles: string) {
    document.body.style.cssText = oldStyles || '';
}